import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { RecommendationService } from '../../recommendation/recommendation.service';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group,
} from '@angular/animations';
import { ResidentialService } from '../../residential.service';
import {
  ScrollToService,
  ScrollToConfigOptions,
} from '@nicky-lenaers/ngx-scroll-to';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-creditcheck-furtheraction',
  templateUrl: './creditcheck-furtheraction.component.html',
  styleUrls: ['./ssn-check.component.css'],
  animations: [
    trigger('flyInOut', [
      state(
        'in',
        style({
          transform: 'translateX(0)',
          opacity: 1,
        })
      ),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate(
            '0.4s 0.1s ease',
            style({
              transform: 'translateX(0)',
            })
          ),
          animate(
            '0.4s ease',
            style({
              opacity: 1,
            })
          ),
        ]),
      ]),
      transition('* => void', [
        group([
          animate(
            '0.4s ease',
            style({
              transform: 'translateX(50px)',
            })
          ),
          animate(
            '0.4s 0.2s ease',
            style({
              opacity: 0,
            })
          ),
        ]),
      ]),
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' })),
      ]),
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' })),
      ]),
    ]),
  ],
})
export class CreditCheckFurutherActionComponent implements OnInit {
  selectedProduct;
  ssnFailedEnergyProvidersList;
  providerContact;
  ssndepostList;
  isChecked = false;
  elem4;
  elem5;
  elem6;
  elem7;
  elem8;
  deviceWidth;
  ansinSSncheck;
  ansinSSncheck1;
  ansinSSncheck2;
  timer;
  time = 1000;
  timeTrue = false;
  hideHome = false;
  vishome;
  user_bot;
  isDisable = false;
  modalRef: BsModalRef;
  accountNumber;
  productName;
  constructor(
    private router: Router,
    private recommendationService: RecommendationService,
    private residentialService: ResidentialService,
    private modalService: BsModalService,
    private _scrollToService: ScrollToService
  ) {
    // console.log.log(this.recommendationService.signupProduct);
    if (!_.isEmpty(this.recommendationService.signupProduct)) {
      this.selectedProduct = this.recommendationService.signupProduct;
      sessionStorage.setItem(
        'signupProduct',
        JSON.stringify(this.selectedProduct)
      );
    } else {
      this.selectedProduct = JSON.parse(
        sessionStorage.getItem('signupProduct')
      );
    }
    // this.getProviderInfo();
    if (!_.isEmpty(this.recommendationService.ssnFailedEnergyProviders)) {
      this.ssnFailedEnergyProvidersList =
        this.recommendationService.ssnFailedEnergyProviders;
      sessionStorage.setItem(
        'ssnFailedEnergyProviders',
        JSON.stringify(this.ssnFailedEnergyProvidersList)
      );
    } else {
      this.ssnFailedEnergyProvidersList = JSON.parse(
        sessionStorage.getItem('ssnFailedEnergyProviders')
      );
    }
    // console.log.log(this.selectedProduct);
    this.ssndepostList = {
      value4: false,
      value5: false,
      value6: false,
      value7: false,
      value8: false,
    };
    this.hideHome = true;
    var vishome = this.hideHome;
    sessionStorage.setItem('hideHome', JSON.stringify(vishome));
    this.deviceWidth = window.innerWidth;

    var postresult = JSON.parse(sessionStorage.getItem('postresult'));
    if (postresult != undefined) {
      this.accountNumber = postresult['data']
        ? postresult['data'].customerId
        : '';
      this.productName = postresult['data']
        ? postresult['data'].rateOfferings['ratePlanName']
        : '';
    }
  }

  onChangeRole(event) {
    this.isChecked = event.target.checked;

    if (this.deviceWidth < 768) {
      this.elem4 = document.getElementById('Someonepleasehelpme');
      this.elem5 = document.getElementById('willtryagainlater');
      this.elem6 = document.getElementById('findoutwhatsgoingon');
      this.elem7 = document.getElementById('nothingwilltryagainlater');
      this.elem8 = document.getElementById('thankyou');
    } else {
      this.elem4 = document.getElementById('Someonepleasehelpme');
      this.elem5 = document.getElementById('willtryagainlater');
      this.elem6 = document.getElementById('findoutwhatsgoingon');
      this.elem7 = document.getElementById('nothingwilltryagainlater');
      this.elem8 = document.getElementById('thankyou');
    }
    if (this.isChecked === true) {
      if (event.target.value === 'Someone please help me') {
        this.ssndepostList = {
          value4: true,
          value5: false,
          value6: false,
          value7: false,
          value8: false,
        };
        this.ansinSSncheck = 'Someone please help me';
        this.user_bot = true;
        this.isDisable = false;
        document.getElementById('openModalButtonForAction').click();
        this.elem4.parentElement.classList.add('active-select');
        if (_.contains(this.elem5.parentElement.classList, 'active-select')) {
          this.elem5.parentElement.classList.remove('active-select');
        }

        this.timer = setTimeout(() => {
          this.timeTrue = true;
          if (this.deviceWidth < 768) {
            this.triggerScrollTo('addf_id');
          }
        }, this.time);
      } else if (event.target.value === 'Will try again later') {
        this.ssndepostList = {
          value4: false,
          value5: true,
          value6: false,
          value7: false,
          value8: false,
        };
        this.ansinSSncheck = 'Will try again later';
        this.ansinSSncheck1 = 'ccc';
        this.user_bot = true;
        this.isDisable = false;
        this.timeTrue = false;
        this.elem5.parentElement.classList.add('active-select');
        if (_.contains(this.elem4.parentElement.classList, 'active-select')) {
          this.elem4.parentElement.classList.remove('active-select');
        }
        if (this.deviceWidth < 768) {
          this.triggerScrollTo('addf_id');
        }
      } else if (event.target.value === 'Find out what’s going on') {
        this.ssndepostList = {
          value4: true,
          value5: false,
          value6: true,
          value7: false,
          value8: false,
        };
        this.ansinSSncheck1 = 'I would like to speak with someone';

        this.elem6.parentElement.classList.add('active-select');
        if (_.contains(this.elem7.parentElement.classList, 'active-select')) {
          this.elem7.parentElement.classList.remove('active-select');
        }
        this.timer = setTimeout(() => {
          this.timeTrue = true;
          if (this.deviceWidth < 768) {
            this.triggerScrollTo('thankAns');
          }
        }, this.time);
      } else if (event.target.value === 'Nothing, will try again later') {
        this.ssndepostList = {
          value4: true,
          value5: false,
          value6: false,
          value7: true,
          value8: false,
        };
        this.ansinSSncheck1 = 'Thank you, goodbye';

        this.elem7.parentElement.classList.add('active-select');
        if (_.contains(this.elem6.parentElement.classList, 'active-select')) {
          this.elem6.parentElement.classList.remove('active-select');
        }
        this.timer = setTimeout(() => {
          this.timeTrue = true;
          if (this.deviceWidth < 768) {
            this.triggerScrollTo('thankAns');
          }
        }, this.time);
      } else if (event.target.value === 'Thank you') {
        if (this.ansinSSncheck1 == 'I would like to speak with someone') {
          if (_.contains(this.elem7.parentElement.classList, 'active-select')) {
            this.elem7.parentElement.classList.remove('active-select');
          }
          this.ssndepostList = {
            value4: false,
            value5: false,
            value6: true,
            value7: false,
            value8: true,
          };
        } else if (this.ansinSSncheck1 == 'Thank you, goodbye') {
          if (_.contains(this.elem6.parentElement.classList, 'active-select')) {
            this.elem6.parentElement.classList.remove('active-select');
          }
          this.ssndepostList = {
            value4: false,
            value5: false,
            value6: false,
            value7: true,
            value8: true,
          };
        }

        this.ansinSSncheck2 = 'Goodbye';
        // this.timer = setTimeout(() => {
        //   this.gotoHome1();
        // }, this.time);
        this.elem8.parentElement.classList.add('active-select');
        this.triggerScrollTo('addf_id');
        this.timer = setTimeout(() => {
          this.timeTrue = true;
          if (this.deviceWidth < 768) {
            this.gotoHome1();
          }
        }, this.time);
      }
    } else {
      this.user_bot = false;
      this.isDisable = true;

      this.timeTrue = false;
      this.ssndepostList = {
        value4: false,
        value5: false,
        value6: false,
        value7: false,
        value8: false,
      };

      this.ansinSSncheck1 = '';
      this.ansinSSncheck2 = '';

      this.elem4.parentElement.classList.remove('active-select');
      this.elem5.parentElement.classList.remove('active-select');
    }
  }

  public triggerScrollTo(destination) {
    const config: ScrollToConfigOptions = {
      target: destination,
      duration: 50,
      easing: 'easeOutElastic',
    };
    this._scrollToService.scrollTo(config);
  }

  hideModal(value) {
    this.ssndepostList = {
      value4: true,
      value5: false,
      value6: false,
      value7: false,
      value8: false,
    };
    this.modalRef.hide();
  }

  ngOnInit() {}

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-lg' })
    );
  }
  gotoHome1() {
    //window.sessionStorage.clear();
    if (!_.isEmpty(sessionStorage.getItem('userObj'))) {
      const hg_accountId = window.location.href.split('/').pop();
      sessionStorage.removeItem('APIESIIDValues');
      sessionStorage.removeItem('esiidValue');
      sessionStorage.removeItem('recommendedProducts');
      sessionStorage.removeItem('userResponse');
      this.router.navigate(['user-settings', hg_accountId]);
    } else {
      this.router.navigate(['/']);
    }
  }

  gotoHome() {
    if (this.ansinSSncheck === 'Someone please help me') {
      this.user_bot = true;
      this.isDisable = false;
      this.timer = setTimeout(() => {
        this.gotoHome1();
      }, this.time);
    } else if (this.ansinSSncheck === 'Will try again later') {
      this.user_bot = true;
      this.isDisable = false;
      this.timer = setTimeout(() => {
        this.gotoHome1();
      }, this.time);
    }
  }
  shop(selectedOption) {
    if (selectedOption === 'prepaid') {
      this.recommendationService.ssnFailedText = selectedOption;
      sessionStorage.setItem(
        'ssnFailedText',
        this.recommendationService.ssnFailedText
      );
      if (!_.isEmpty(this.ssnFailedEnergyProvidersList)) {
        this.recommendationService.ssnFailedEnergyProviders = [];
        sessionStorage.setItem(
          'ssnFailedEnergyProviders',
          JSON.stringify(this.recommendationService.ssnFailedEnergyProviders)
        );
      }
    } else {
      this.recommendationService.ssnFailedText = selectedOption;
      if (!_.isEmpty(this.ssnFailedEnergyProvidersList)) {
        this.recommendationService.ssnFailedEnergyProviders =
          this.ssnFailedEnergyProvidersList;
      }
      this.recommendationService.ssnFailedEnergyProviders.push(
        this.selectedProduct.energy_provider
      );
      sessionStorage.setItem(
        'ssnFailedText',
        this.recommendationService.ssnFailedText
      );
      sessionStorage.setItem(
        'ssnFailedEnergyProviders',
        JSON.stringify(this.recommendationService.ssnFailedEnergyProviders)
      );
    }
    this.router.navigate([
      'recommendation/compare-product',
      this.recommendationService.hg_accountId,
    ]);
  }

  getProviderInfo() {
    this.residentialService.getProviderContactInfo().subscribe((res: any) => {
      const result = JSON.stringify(res);
      let arr = JSON.parse(result);
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].provider_name === this.selectedProduct.energy_provider) {
          this.providerContact = arr[i];
        }
      }
    });
  }
}
